<script>
  import Alert from "../Alerts/Alert.svelte";
  import { translate } from "../../i18n/i18next.js";
  import {useEProtectorDriverStatus} from "../../hooks/license/useEProtectorDriverStatus.js";

  const statusData = useEProtectorDriverStatus()
</script>

{#if $statusData?.status !== "Running"}
  <Alert type="error">
    {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.messages.driverNotInstalled")}
  </Alert>
{/if}
